import { Alert as AntAlert, notification } from "antd";
import {
  AlertError,
  AlertInfo,
  AlertSuccess,
  AlertWarning,
} from "assets/icons";
import "./style.scss";

const AlertNotification = (type, message) => {
  const iconMap = {
    success: <AlertSuccess />,
    error: <AlertError />,
    warning: <AlertWarning />,
    info: <AlertInfo />,
  };

  notification.open({
    description: (
      <AntAlert
        message={message}
        type={type}
        className="custom-alert"
        icon={iconMap[type]}
        showIcon
      />
    ),
    className: "custom-notification",
    duration: 3,
    closable: true,
  });
};

export default AlertNotification;
